// src/content/infrastructure/ui-services/faqsUiService.ts

import type { Post } from "~/src/post/domain/models/Post";
import type { NitroFetchOptions } from "nitropack";
import type { Faq } from "~/src/content/domain/models/Faqs";
import { useCompetitionStore } from "~/app/stores/competitionStore";

interface PostUiService {
  getFaqs: () => Promise<Faq[] | undefined>;
}

const getFaqs = async (): Promise<Faq[] | undefined> => {
  const opts = {
    params: {
      per_page: 100,
    },
  };
  const response = await fetchFaqs(opts);
  return response || undefined;
};

const faqsUiService = (): PostUiService => ({
  getFaqs,
});

export default faqsUiService;

function getCurrentRegionId(): number | undefined {
  const { region } = useCompetitionStore();
  return region?.id;
}

async function fetchFaqs(opts: NitroFetchOptions<any>): Promise<Faq[] | undefined> {
  const regionId = getCurrentRegionId();
  if (!regionId) {
    console.error("Invalid regionId.");
    return undefined;
  }

  try {
    const data = await $fetch<Post[]>(`/api/cms/${regionId}/faqs`, opts);
    if (data?.length) {
      return data;
    } else {
      console.error("Faq/s not found in CMS.");
    }
  } catch (e) {
    console.error("Error fetching faqs.");
  }
}
